import { styled } from '@linaria/react';
import { layout, semantic, space } from '../../theme/tokens';

export const Body = styled.div`
  padding: ${space['space-300']} ${space['space-400']} ${space['space-600']};
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};

  [data-testid='basket-contents'] > *:first-child {
    padding-right: ${space['space-1200']};
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-600']} ${space['space-1200']};

    [data-testid='basket-contents'] > *:first-child {
      padding-right: 0;
    }
  }
`;

export const ActionBar = styled.div`
  display: flex;
  gap: ${space['space-300']};
  padding: ${space['space-400']};
  background: ${semantic.bg.canvas};
  border-top: 1px solid ${semantic.border.subtle};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-600']} ${space['space-1200']};
  }
`;
